import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WaterHero from './components/WaterHero';
import WaterProblems from './components/WaterProblems';
import WaterSystems from './components/WaterSystems';
import WaterBenefits from './components/WaterBenefits';

const WATER_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/water-purification#webpage`,
      url: `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/water-purification`,
      name: 'Purificación de Agua en Georgia | Sistemas Puronics – ORPM Investment LLC',
      description: 'Sistemas de purificación y filtración de agua para el hogar en Georgia. Prueba de agua gratuita. Sistemas Puronics certificados. Llama al +1 (561) 512-2820.',
      inLanguage: 'es-US',
      isPartOf: {
        '@type': 'WebSite',
        url: import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com',
        name: 'ORPM Investment LLC',
      },
    },
    {
      '@type': 'Service',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/water-purification#service`,
      name: 'Purificación de Agua para el Hogar',
      description: 'Instalación de sistemas de purificación y filtración de agua certificados Puronics para hogares y negocios en Georgia.',
      provider: {
        '@type': 'LocalBusiness',
        name: 'ORPM Investment LLC',
        telephone: '+15615122820',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Lawrenceville',
          addressRegion: 'GA',
          postalCode: '30044',
          addressCountry: 'US',
        },
      },
      areaServed: {
        '@type': 'State',
        name: 'Georgia',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Sistemas de Purificación de Agua',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Sistema de Filtración de Agua Completo',
              description: 'Sistema de filtración de agua para toda la casa con tecnología avanzada.',
              brand: { '@type': 'Brand', name: 'Puronics' },
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Purificador de Agua para el Hogar',
              description: 'Purificador de agua de alto rendimiento para uso doméstico.',
              brand: { '@type': 'Brand', name: 'Puronics' },
            },
          },
        ],
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '¿Qué es un sistema de purificación de agua?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Un sistema de purificación de agua elimina contaminantes, cloro, metales pesados y bacterias del agua del hogar, proporcionando agua limpia y segura para toda la familia.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Ofrecen prueba de agua gratuita en Georgia?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí, ORPM Investment LLC ofrece pruebas de agua gratuitas en Georgia. Contáctanos al +1 (561) 512-2820 para programar tu prueba sin costo.',
          },
        },
      ],
    },
  ],
};

export default function WaterPurification() {
  useEffect(() => {
    const id = 'schema-water';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(WATER_SCHEMA);
    document.title = 'Purificación de Agua en Georgia | Sistemas Puronics – ORPM Investment LLC';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Sistemas de purificación y filtración de agua para el hogar en Georgia. Prueba de agua gratuita. Sistemas Puronics certificados. Llama al +1 (561) 512-2820.');
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1" id="water-form">
        <WaterHero />
        <WaterProblems />
        <WaterSystems />
        <WaterBenefits />
      </main>
      <Footer />
    </div>
  );
}
